<template>
  <div v-show="menuOpen" class="absolute left-0 z-50 h-page-mobile min-w-full overflow-y-auto bg-white">
    <h2 class="mx-6 mb-2 mt-6 text-2xl font-medium">Menu</h2>
    <ul class="mx-6 mb-4 mt-6 flex flex-col gap-4">
      <li v-for="appRoute in visibleRoutes" :key="appRoute.title">
        <ui-header-hamburger-menu-nav-item role="menuitem" v-bind="appRoute" @click="menuOpen = !menuOpen" />
      </li>
      <div class="flex h-14 items-center justify-end">
        <ui-social />
      </div>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useWindowSize } from '@vueuse/core';
import { hamburgerMenuRoutes } from './index';
import { computed, watch } from 'vue';
import { BREAKPOINTS_INT } from '@/constants';
import { getVisibleRoutes } from '@/common/helpers';

const { width } = useWindowSize();

const visibleRoutes = computed(() => getVisibleRoutes(hamburgerMenuRoutes));

watch(
  () => width.value,
  () => {
    if (width.value > BREAKPOINTS_INT.md) {
      menuOpen.value = false;
    }
  }
);

const menuOpen = defineModel<boolean>();
</script>
